import * as React from 'react'
import { Operation } from '../domain/Operation'
import Bottlenecks from '../helper/bottlenecks'
import Shorten from '../helper/shorten'
import TracepointIndicator from '../monitor/operation/tracepoint-indicator'
import { TransactionPageType } from './transactionPageType'

interface Props {
    operation: Operation
    icon?: any
    full: boolean
    showServicename: boolean
}

interface TransactionNameInterface {
    name: string
    tag?: string
}
export function parseTransactionName(identifier: string | undefined): TransactionNameInterface {
    if (!identifier) {
        return {
            name: '',
            tag: undefined,
        }
    }

    const [name, tag, ...unknownRest] = identifier.split('##')

    return { name, tag }
}

export class TransactionName extends React.PureComponent<Props> {
    static defaultProps = {
        showServicename: false,
    }

    public render() {
        const transactionIdentifier = this.props.operation.identifier || this.props.operation.name
        const transactionName = parseTransactionName(transactionIdentifier)
        const { active } = this.props.operation

        return (
            <React.Fragment>
                {this.props.icon ? <span className={this.props.icon} /> : null}
                {this.props.operation.bottlenecks ? (
                    <Bottlenecks bottlenecks={this.props.operation.bottlenecks} bottleneckTypes={[]} />
                ) : null}
                {this.props.showServicename ? <span className="text-muted">[{this.props.operation.service}] </span> : null}
                {active ? (
                    <Shorten string={transactionName.name} />
                ) : (
                    <span className="tw-font-weight-normal word-break">{transactionName.name}</span>
                )}
                <TransactionPageType transaction={this.props.operation} />
                {transactionName.tag ? (
                    <div
                        data-tooltip-text={
                            'This transaction shows data of calls to' +
                            transactionName.name +
                            ' that were tagged with ' +
                            transactionName.tag
                        }
                        className={'label label-default tw-ml-8 tw-tooltip tw-tooltip-dataText tw-tooltip--right'}
                    >
                        {transactionName.tag}
                    </div>
                ) : null}
                {this.props.full && this.props.operation.name !== transactionIdentifier ? (
                    <div className="small text-mute">{this.props.operation.name}</div>
                ) : null}
                <TracepointIndicator operation={this.props.operation} />
            </React.Fragment>
        )
    }
}
